import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../components/public/Navbar';
import Footer from '../components/public/Footer';

const MainLayout = () => {
    const location = useLocation();

    // Check if current page is a diagnosis page
    const isDiagnosisPage = location.pathname.includes('begin-with-clarity') ||
        location.pathname.includes('diagnosis-report');

    return (
        <div className="main-layout">
            <Navbar />
            <main className="main-content">
                <Outlet />
            </main>
            <Footer />


        </div>
    );
};

export default MainLayout;
